import React, { useState, useEffect } from "react";
import { Col, Row } from "reactstrap";
import SubDashBreif from "./SubDashBreif";
import FileTabs from "./FileTabs";
import "./index.scss";
import { useDispatch } from "react-redux";
import { getFilesGraphData, getTotalPacketsPieChartData, getEditFilesGraphData, getDataCount } from "../../../context/actions/subDashboard";
import { pieChartOptions, barGraphOptions } from '../../../utils/constants';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import NoRecord from "../../../components/common/NoRecord";
import { capitalizeFirstLetter } from "../../../utils/common";
import { monthNames } from "../../../utils/constants";

const SubDashBlock = ({ locations, pageLoading }) => {


  let location = locations?.docs?.[0]?._id;

  let [documentsGraphData, setDocumentsGraphData] = useState([]);
  let [editedDocumentsInGraph, setEditedDocumentsInGraph] = useState([]);
  let [pieChartData, setPieChatData] = useState([]);
  let [pieChartOption, setPieChartOption] = useState(pieChartOptions);
  let [isLoading, setIsLoading] = useState(false);
  let [documentsCount, setDocumentsCount] = useState();
  let [packetsCount, setPacketsCount] = useState();
  let [editedDocumentCount, setEditedDocumentCount] = useState();
  let [selectedLocation, setSelectedLocation] = useState(location);



  useEffect(() => {
    setSelectedLocation(location)
    if (location) {
      handleFileOptionClick('month', location);
      handleEditFileOptionClick('month', location);
      handleBacklogOptionClick('month', location);
      getDocumentsPacketesCount(location)
    }
  }, [location]);


  const getDocumentsPacketesCount = async (location) => {
    let payload = { location: location }
    setIsLoading(true)
    dispatch(getDataCount(payload, (res) => {
      if (res?.currentYearUploadedPackets && res?.currentYearUploadedPackets.length) {
        setDocumentsCount(res?.currentYearUploadedPackets[0].numberOfFiles);
        setPacketsCount(res?.currentYearUploadedPackets[0].numberOfPackets);
      } else {
        setDocumentsCount(0);
        setPacketsCount(0);
      }
      if (res?.currentYearEditedFiles && res?.currentYearEditedFiles.length) {
        setEditedDocumentCount(res?.currentYearEditedFiles[0].totalEditedFilesCount);
      } else {
        setEditedDocumentCount(0)
      }
      setIsLoading(false)
    }))

  }

  // const handleFileOptionClick = async (val, location) => {
  //   let payload = { dateFilter: val, location: location }
  //   let Val = capitalizeFirstLetter(val);
  //   await dispatch(getFilesGraphData(payload, (res) => {
  //     let documents = [];
  //     if (res?.totalFiles && res?.totalFiles.length) {
  //       documents = res?.totalFiles.map(x => {
  //         if (Val === 'Month') {
  //           return [monthNames[x._id], x.numberOfFiles]
  //         } else if (Val === 'Quarter') {
  //           return [x._id.quarter, x.numberOfFiles]
  //         } else {
  //           let year = x._id
  //           return [year.toString(), x.numberOfFiles]
  //         }

  //       });

  //       documents = [[Val, "Documents"], ...documents];
  //     }
  //     setDocumentsGraphData(documents);
  //   }))

  // }

  const handleFileOptionClick = async (val, location) => {
    let payload = { dateFilter: val, location: location }
    let Val = capitalizeFirstLetter(val);
    await dispatch(getFilesGraphData(payload, (res) => {
      let documents = [];

      if (res) {

        if (res?.totalFiles && res?.totalFiles.length) {
          if (res?.totalFiles.length == 1) {

            if (Val == "Year") {
              setDocumentsGraphData([{ _id: res.totalFiles[0]._id, numberOfFiles: res.totalFiles[0].numberOfFiles }])
            }
            else if (Val == "Quarter") {
              setDocumentsGraphData([{ _id: res.totalFiles[0]._id.quarter + " " + "Quarter", numberOfFiles: res.totalFiles[0].numberOfFiles }])
            }

            else setDocumentsGraphData([{ _id: monthNames[res.totalFiles[0]._id], numberOfFiles: res.totalFiles[0].numberOfFiles }])
          } else {
            documents = res.totalFiles.map((x) => {
              if (Val === "Month") {
                return [monthNames[x._id], x.numberOfFiles];
              } else if (Val === "Quarter") {
                return [x._id.quarter, x.numberOfFiles];
              } else {
                let year = x._id;

                return [year.toString(), x.numberOfFiles];
              }
            });



            documents = [[Val, "Documents"], ...documents];
            setDocumentsGraphData(documents);
          }
        }
      }
    }))

  }



  // const handleEditFileOptionClick = async (val, location) => {
  //   let payload = { dateFilter: val, location: location };
  //   let Val = capitalizeFirstLetter(val);
  //   await dispatch(getEditFilesGraphData(payload, (res) => {

  //     let editedFiles = [];
  //     if (res?.editedFiles && res?.editedFiles.length) {
  //       editedFiles = res?.editedFiles.map(x => {
  //         if (Val === 'Month') {
  //           return [monthNames[x._id], x.totalEditedFilesCount]
  //         } else if (Val === 'Quarter') {
  //           return [x._id, x.totalEditedFilesCount]
  //         } else {
  //           let year = x._id
  //           return [year.toString(), x.totalEditedFilesCount]
  //         }

  //       });
  //       editedFiles = [[Val, "Documents"], ...editedFiles];
  //     }
  //     setEditedDocumentsInGraph(editedFiles)

  //   }))

  // }


  const handleEditFileOptionClick = async (val, location) => {
    let payload = { dateFilter: val, location: location };
    let Val = capitalizeFirstLetter(val);
    await dispatch(getEditFilesGraphData(payload, (res) => {

      let editedFiles = [];

      if (res) {

        if (res?.editedFiles && res?.editedFiles.length) {
          if (res?.editedFiles.length == 1) {

            if (Val == "Year") {

              setEditedDocumentsInGraph([{ _id: res.editedFiles[0]._id, totalEditedFilesCount: res.editedFiles[0].totalEditedFilesCount }])

            }
            else if (Val == "Quarter") {
              setEditedDocumentsInGraph([{ _id: res.editedFiles[0]._id + " " + "Quarter", totalEditedFilesCount: res.editedFiles[0].totalEditedFilesCount }])
            }

            else setEditedDocumentsInGraph([{ _id: monthNames[res.editedFiles[0]._id], totalEditedFilesCount: res.editedFiles[0].totalEditedFilesCount }])
          } else {
            editedFiles = res.totalFiles.map((x) => {
              if (Val === "Month") {
                return [monthNames[x._id], x.totalEditedFilesCount];
              } else if (Val === "Quarter") {
                return [x._id.quarter, x.totalEditedFilesCount];
              } else {
                let year = x._id;

                return [year.toString(), x.totalEditedFilesCount];
              }
            });



            editedFiles = [[Val, "Documents"], ...editedFiles];
            setEditedDocumentsInGraph(editedFiles);
          }
        }
      }

    }))

  }



  /**
  * @description method call get backlog data in pie chart on select box changes
  */


  //  const handleBacklogOptionClick = async (val, location) => {
  //   let payload = { dateFilter: val, location: location }
  //   await dispatch(getTotalPacketsPieChartData(payload, (res) => {
  //     let uploadedPackets = [];
  //     if (res?.totalPackets && res?.totalPackets.length) {
  //       uploadedPackets.push(["Completed", res?.totalPackets[0].numberOfProcessPackets])
  //       uploadedPackets.push(["Backlog", res?.totalPackets[0].numberOfPackets - res?.totalPackets[0].numberOfProcessPackets])
  //       uploadedPackets = [["Task", "Remaining"], ...uploadedPackets];
  //     }

  //     setPieChatData(uploadedPackets);

  //   }))

  // }


  const handleBacklogOptionClick = async (val, location) => {

    let payload = { dateFilter: val, location: location }
    await dispatch(getTotalPacketsPieChartData(payload, (res) => {
      let uploadedPackets = [];
      if (res?.totalPackets && res?.totalPackets.length) {
        if (res?.totalPackets.length == 1) {
          if (val == "year") {


            setPieChatData([{ _id: res.totalPackets[0]._id, numberOfProcessPackets: res.totalPackets[0].numberOfProcessPackets }]);
          }
          else {

            setPieChatData([{ _id: monthNames[res.totalPackets[0]._id], numberOfProcessPackets: res.totalPackets[0].numberOfProcessPackets }]);
          }
        }
        else {

          uploadedPackets.push(["Completed", res?.totalPackets[0].numberOfProcessPackets])
          uploadedPackets.push(["Backlog", res?.totalPackets[0].numberOfPackets - res?.totalPackets[0].numberOfProcessPackets])
          uploadedPackets = [["Task", "Remaining"], ...uploadedPackets];
          setPieChatData(uploadedPackets);
        }
      }

      // setPieChatData(uploadedPackets);

    }))

  }



  const [activeTab, setActiveTab] = useState(0);

  /**
  * @description method call get subdashboard data by locationId
  */
  const toggle = async (tab, id) => {
    setPieChartOption(pieChartOption);
    setSelectedLocation(id)
    handleFileOptionClick('month', id);
    handleEditFileOptionClick('month', id);
    handleBacklogOptionClick('month', id);
    getDocumentsPacketesCount(id)

    if (activeTab !== tab) setActiveTab(tab);

  };
  const dispatch = useDispatch();

  var settings = {
    infinite: false,
    speed: 500,
    slidesToShow: locations?.docs?.length >= 3 ? 3 : locations?.docs?.length >= 2 ? 2 : 1,
    slidesToScroll: 1,
    variableWidth: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 850,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  };
  return (
    <>
      <div className="sub-dash-blc">
        {!pageLoading ? locations?.docs && locations?.docs.length !== 0 ? (<> <Row className="sub-dash-rw">
          <Slider {...settings} className={`${locations?.docs?.length > 3 ? "sub-dashboard-slider-items" : ""}`}>
            {locations?.docs?.map((item, inx) => {
              return (
                <Col
                  lg="3"
                  onClick={() => {
                    toggle(inx, item?._id);
                  }}
                >
                  <SubDashBreif data={item} className={`${activeTab === inx ? "active" : ""}`} />
                </Col>
              );
            })}
          </Slider>
        </Row>
          <FileTabs packetsCount={packetsCount} documentsCount={documentsCount} documentsGraphData={documentsGraphData} _handleFileOptionClick={(id) => handleFileOptionClick(id, selectedLocation)} _handleBacklogOptionClick={(id) => handleBacklogOptionClick(id, selectedLocation)} _handleEditFileOptionClick={(id) => handleEditFileOptionClick(id, selectedLocation)} pieChartData={pieChartData} pieChartOptions={pieChartOption} barGraphOptions={barGraphOptions} editedDocumentCount={editedDocumentCount} isLoading={isLoading} editedDocumentsInGraph={editedDocumentsInGraph} />
        </>
        ) : <NoRecord />

          : null

        }
      </div>
    </>
  );
};
export default SubDashBlock;
